import { Vue } from 'vue-property-decorator';
import { GlobalVariables } from '@/libs/core/global';

Vue.filter('formatNumber', (value : string, defaultValue = '') => {
    if (value && !isNaN(Number(value))) {
        return new Intl.NumberFormat(GlobalVariables.lang).format(Number(value));
    }
    return defaultValue;
})